import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import GameDetail from "./pages/GameDetail";
import GamePressKit from "./pages/GamePressKit";
import Subscribe from "./pages/Subscribe";
import AdminDashboard from "./pages/AdminDashboard";
import { Toaster } from "./components/ui/toaster";
import { ThemeProvider } from "./context/ThemeContext";
import BubbleCursor from "./components/BubbleCursor";
import SharkMascot from "./components/SharkMascot";
import CursorSwitch from "./components/CursorSwitch";
import { captureRefFromUrl } from "./lib/referral";

function App() {
  useEffect(() => {
    captureRefFromUrl();
  }, []);

  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/game/:id" element={<GameDetail />} />
            <Route path="/game/:id/presskit" element={<GamePressKit />} />
            <Route path="/signup" element={<Subscribe />} />
            <Route path="/subscribe" element={<Subscribe />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <SharkMascot />
        </BrowserRouter>
        <CursorSwitch />
        <BubbleCursor />
        <div className="grain-overlay" aria-hidden="true" />
        <Toaster />
      </div>
    </ThemeProvider>
  );
}

export default App;
